import { render, staticRenderFns } from "./ServiceAreasCutOffModal.vue?vue&type=template&id=0a983b2c&scoped=true&"
import script from "./ServiceAreasCutOffModal.vue?vue&type=script&lang=js&"
export * from "./ServiceAreasCutOffModal.vue?vue&type=script&lang=js&"
import style0 from "./ServiceAreasCutOffModal.vue?vue&type=style&index=0&id=0a983b2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a983b2c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a983b2c')) {
      api.createRecord('0a983b2c', component.options)
    } else {
      api.reload('0a983b2c', component.options)
    }
    module.hot.accept("./ServiceAreasCutOffModal.vue?vue&type=template&id=0a983b2c&scoped=true&", function () {
      api.rerender('0a983b2c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/TeamSettings/ServiceAreas/ServiceAreasCutOffModal.vue"
export default component.exports